import React from 'react';
import {
  FaHome,
  FaChevronLeft,
  FaChevronRight,
  FaTimes,
  FaBars,
  FaDatabase,
  FaFilePdf,
  FaUserShield,
  FaChartLine,
  FaRobot,
  FaFolderOpen,
  FaBuilding
} from 'react-icons/fa';

const Sidebar = ({
  sidebarOpen,
  setSidebarOpen,
  activeSection,
  setActiveSection,
  userInfo,
  fullscreenMode,
  onDataClick
}) => {
  // Hide sidebar in fullscreen mode
  if (fullscreenMode) return null;

  // Sidebar menu items (ORDER MATTERS)
  const getSidebarItems = () => {
    const items = [
      { id: 'home', label: 'Overview', icon: <FaHome /> },

      // 🧠 AI Section (2nd position)
      { id: 'data', label: 'Cognitive Data', icon: <FaDatabase /> },

      { id: 'upload', label: 'Document Ingestion', icon: <FaRobot /> },
      { id: 'upload-pdf', label: 'Doc Vault', icon: <FaFilePdf /> },
    ];

    // Admin-only menu
    if (userInfo?.role === 'admin' || userInfo?.role === 'superadmin') {
      items.push(
        {
          id: 'companies',
          label: 'Companies',
          icon: <FaBuilding />
        },
        {
          id: 'user-access',
          label: 'User Management',
          icon: <FaUserShield />
        }
      );
    }

    return items;
  };

  const sidebarItems = getSidebarItems();

  const handleSectionClick = (sectionId) => {
    if (sectionId === 'data') {
      onDataClick?.();
    } else {
      setActiveSection(sectionId);
    }
  };

  return (
    <div
      className={`fixed inset-y-0 left-0 z-30 pt-16 h-screen bg-white dark:bg-gray-800 shadow-lg transition-all duration-300
      ${sidebarOpen ? 'w-64' : 'w-16'}
      ${sidebarOpen ? 'translate-x-0' : '-translate-x-full lg:translate-x-0'}`}
    >
      {/* Header */}
      <div className="flex items-center justify-between h-16 px-4 border-b border-gray-200 dark:border-gray-700">
        {sidebarOpen ? (
          <div className="flex items-center">
            <FaHome className="h-6 w-6 text-blue-600" />
            <span className="ml-3 text-lg font-bold text-gray-900 dark:text-white">
              NIRAFINHUB
            </span>
          </div>
        ) : (
          <FaHome className="h-6 w-6 text-blue-600 mx-auto" />
        )}

        <button
          onClick={() => setSidebarOpen(!sidebarOpen)}
          className="p-2 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-700 text-gray-600 dark:text-gray-300"
        >
          {sidebarOpen ? <FaChevronLeft /> : <FaChevronRight />}
        </button>
      </div>

      {/* Menu */}
      <nav className="p-4 space-y-2 overflow-y-auto h-[calc(100vh-4rem)]">
        {sidebarItems.map((item) => (
          <button
            key={item.id}
            onClick={() => handleSectionClick(item.id)}
            title={!sidebarOpen ? item.label : ''}
            className={`flex items-center w-full p-3 rounded-lg transition-colors
              ${
                activeSection === item.id
                  ? item.id === 'data'
                    ? 'bg-green-600 text-white' // 🧠 AI Highlight
                    : 'bg-blue-600 text-white' // Regular blue for other items
                  : 'text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700'
              }
            `}
          >
            <span className="text-lg">{item.icon}</span>
            {sidebarOpen && (
              <span className="ml-3 font-medium transition-opacity duration-300">
                {item.label}
              </span>
            )}
          </button>
        ))}
      </nav>
    </div>
  );
};

export default Sidebar;